<div class="Modal ModalEsqueciSenha">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Ajuda</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="onNoClick()">
      close
    </span>
  </div>
  <div class="ModalContent">
    <form [formGroup]="passwordFormGroup" (ngSubmit)="resetPassword()">
      <h1 class="TtlModal">Vamos criar uma nova senha!</h1>
      <p class="TxtModal mb-4">
        Para que o processo seja seguro, informe seu CPF no campo abaixo.
        Enviaremos uma senha via SMS para o número vinculado ao cadastro.
      </p>
      <mat-form-field class="InputPadrao mt-3 mb-64">
        <mat-label>Qual seu CPF ?</mat-label>
        <input
          type="tel"
          formControlName="cpf"
          matInput
          mask="CPF_CNPJ"
          maxlength="14"
        />
        <mat-hint>Somente números</mat-hint>
      </mat-form-field>
      <button
        mat-button
        class="Btn BtnPadrao"
        [disabled]="!passwordFormGroup.valid"
      >
        Enviar senha
        <span class="material-icons"> east </span>
      </button>
    </form>
  </div>
</div>
